// extracted by mini-css-extract-plugin
export default {"wrapper":"ZgMAiY","navLink":"nXYHpo","active":"VGqSwi","logo":"XmTs3S","user":"Bknozv","userIcon":"fHFdPg"};